import { getConvenienceVariables } from '../convenienceVariables';
/*
  The commented out text above each variable
  should match the condition's name in Kentico
  and the variable key should match its codename
*/
export const cancerInsuranceConditions = {
    // User has seen the plan explanation content
    cancer_condition_has_seen_plan_exp: (data) => {
        return data.user.cancer.seenPlanExp === true;
    },
    // User hasn't seen the plan explanation content
    cancer_condition_hasnt_seen_plan_exp: (data) => {
        return data.user.cancer.seenPlanExp !== true;
    },
    // Plan offers some coverage for cancer recurrence
    cancer_condition_plan_recurrence_coverage: (data) => {
        return Boolean(data.plan.hasRecurrenceCoverage);
    },
    // Plan does not have recurrence coverage
    cancer_condition_plan_no_recurrence_coverage: (data) => {
        return Boolean(data.plan.hasRecurrenceCoverage === false);
    },
    // Plan has a waiting period
    cancer_condition_plan_has_waiting_period: (data) => {
        return Boolean(data.plan.waitingPeriod);
    },
    // Plan coverage type is per procedure
    cancer_condition_plan_per_procedure_coverage_type: (data) => {
        return data.plan.coverageType === 'per_procedure';
    },
    // Plan does cover preventive services
    cancer_condition_plan_preventive_coverage: (data) => {
        return Boolean(data.plan.cancerPreventive);
    },
    // Plan coverage type is lump sum
    cancer_condition_plan_lump_sum_coverage_type: (data) => {
        return data.plan.coverageType === 'lump_sum';
    },
    // Plan has additional service rider
    cancer_condition_plan_has_service_rider: (data) => {
        return Boolean(data.plan.hasServicesRider);
    },
    // User has not made a decision about cancer coverage yet
    cancer_condition_has_not_made_covg_decision: (data) => {
        return (data.user.cancer.selectionStatus !== 'Selected' &&
            data.user.cancer.selectionStatus !== 'Waived');
    },
    // User has selected cancer coverage
    cancer_condition_has_selected_covg: (data) => {
        return Boolean(data.user.cancer.selectionStatus === 'Selected');
    },
    // User has selected or waived Cancer coverage
    cancer_condition_has_selected_or_waived_covg: (data) => {
        return (data.user.cancer.selectionStatus === 'Selected' ||
            data.user.cancer.selectionStatus === 'Waived');
    },
    //User has eligible significant other
    cancer_condition_has_eligible_so: (data) => {
        const convVars = getConvenienceVariables(data);
        return Boolean(convVars.cancer_hasEligibleSignificantOther);
    },
    // User has eligible kid(s)
    cancer_condition_has_eligible_kids: (data) => {
        const convVars = getConvenienceVariables(data);
        return convVars.cancer_eligibleKidsNum > 0;
    },
    // User has eligible family members
    cancer_condition_has_eligible_family_members: (data) => {
        const convVars = getConvenienceVariables(data);
        return Boolean(convVars.cancer_eligibleKidsNum > 0 ||
            convVars.cancer_hasEligibleSignificantOther);
    },
    // User has exactly 2 eligible children
    cancer_condition_has_exactly_two_eligible_kids: (data) => {
        const convVars = getConvenienceVariables(data);
        return convVars.cancer_eligibleKidsNum === 2;
    },
    // User has eligible significant other AND eligible kid(s)
    cancer_condition_has_eligible_so_and_eligible_kids: (data) => {
        const convVars = getConvenienceVariables(data);
        return Boolean(convVars.cancer_eligibleKidsNum > 0 &&
            convVars.cancer_hasEligibleSignificantOther);
    },
    // User has eligible dependents and has waived cancer covg or hasn’t made a selection yet
    cancer_condition_user_has_elig_fam_hasnt_selected_covg: (data) => {
        const convVars = getConvenienceVariables(data);
        return Boolean(data.user.cancer.selectionStatus !== 'Selected' &&
            (convVars.cancer_eligibleKidsNum > 0 ||
                convVars.cancer_hasEligibleSignificantOther));
    },
};
//# sourceMappingURL=cancerInsurance.js.map